export class hour_min{
    days:string;
    hours: any;
    constructor(days,hours){
        this.days = days;
        this.hours = hours;
      }
}